document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".pendants-videos-top");
  const track = document.querySelector(".pendants-videos-track");
  if (!root || !track) return;

  const cells = Array.from(track.querySelectorAll(".pendants-video-cell"));
  const videos = cells.map(c => c.querySelector("video")).filter(Boolean);
  if (!videos.length) return;

  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const isDesktop = window.matchMedia("(min-width: 750px)").matches;

  const stopVideo = (v) => {
    try {
      v.pause();
      v.currentTime = 0;
    } catch (e) {}
  };

  // DESKTOP: all play + loop
  if (isDesktop) {
    videos.forEach(v => {
      try {
        v.muted = true;
        v.playsInline = true;
        v.loop = true;
        v.play().catch(() => {});
      } catch (e) {}
    });
    return;
  }

  // MOBILE: play 10s then smooth scroll to next
  if (!isMobile) return;

  let index = 0;
  let timer = null;
  let isAnimating = false;

  const stopAll = () => videos.forEach(stopVideo);

  const playOnlyFor10s = async (i) => {
    videos.forEach((v, idx) => {
      if (idx !== i) stopVideo(v);
    });

    const v = videos[i];
    if (!v) return;

    try {
      v.muted = true;
      v.playsInline = true;
      v.loop = false;
      v.currentTime = 0;
      await v.play();
    } catch (e) {}
  };

  const smoothScrollToIndex = (i, duration = 1000) => {
    return new Promise((resolve) => {
      const cell = cells[i];
      if (!cell) return resolve();

      const start = track.scrollLeft;
      const end = cell.offsetLeft;
      const delta = end - start;

      if (Math.abs(delta) < 2) return resolve();

      const startTime = performance.now();
      isAnimating = true;

      const easeInOut = (t) =>
        t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

      const step = (now) => {
        const t = Math.min((now - startTime) / duration, 1);
        track.scrollLeft = start + delta * easeInOut(t);

        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          isAnimating = false;
          resolve();
        }
      };

      requestAnimationFrame(step);
    });
  };

  const run = async () => {
    clearTimeout(timer);
    await playOnlyFor10s(index);
    timer = setTimeout(goNext, 10000);
  };

  const goToIndex = async (newIndex) => {
    clearTimeout(timer);
    stopAll();

    index = (newIndex + cells.length) % cells.length;

    await smoothScrollToIndex(index, 600);
    run();
  };

  const goNext = async () => {
    const currentVideo = videos[index];
    if (currentVideo) stopVideo(currentVideo);

    const next = (index + 1) % cells.length;

    await smoothScrollToIndex(next, 1000);
    index = next;

    run();
  };

  const prevBtn = root.querySelector(".pendants-video-prev");
  const nextBtn = root.querySelector(".pendants-video-next");

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      goToIndex(index - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      goToIndex(index + 1);
    });
  }

  const updateIndexFromScroll = () => {
    if (isAnimating) return;

    const pos = track.scrollLeft;
    let closest = 0;
    let best = Infinity;

    cells.forEach((cell, idx) => {
      const d = Math.abs(cell.offsetLeft - pos);
      if (d < best) {
        best = d;
        closest = idx;
      }
    });

    if (closest !== index) {
      index = closest;
      run();
    }
  };

  let scrollDebounce = null;

  track.addEventListener("scroll", () => {
    clearTimeout(scrollDebounce);
    scrollDebounce = setTimeout(updateIndexFromScroll, 120);
  });

  const kickstart = () => run();

  window.addEventListener("touchstart", kickstart, { passive: true, once: true });
  window.addEventListener("click", kickstart, { once: true });

  stopAll();
  smoothScrollToIndex(0, 0).then(run);
});